<template>
    <div class="text-center">
        <v-dialog v-model="dialog" width="500">
            <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" color="primary" icon>
                    <v-icon :title="'Motivo do Cancelamento'">error</v-icon></v-btn>
            </template>
            <v-card>

                <v-card-title class="text-h6 primary white--text">
                    Motivo do Cancelamento
                </v-card-title>

                <v-card-text class=" pt-5 text-center">
                    <p style="font-size: medium;">{{ motivo }} </p>
                </v-card-text>
                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialog = false">
                        fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
export default {
    name: "DialogMotivoCancelamento",
    props: {
        motivo: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            dialog: false,
        }
    },
}
</script>